export default class Helpers {

    //Checks numeric values
    static isNumeric = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    static isNumericV2 = (value) => {

        const regex = /^\d+$/;
        var result = regex.test(value);
        console.log("***isNumericV2 : " + result + " - value: "+value);
        return result;
    }

    static formatCurrency = (amount, includeDecimal = true) => {
        const formattedCurrency = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: includeDecimal ? 2 : 0,
            maximumFractionDigits: 2,
        }).format(amount);

        return formattedCurrency;
    }

    static truncateWithEllipsis(name, maxLength = 20) {
        if (!name) return "";
        return name.length > maxLength 
          ? name.substring(0, maxLength).replace(/\s+$/, "") + "…" 
          : name;
    }      
};